import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from './core/guards/authentication.guard';
import { UsersComponent } from "@/modules/users/users.component";
import { ClustersComponent } from "@/modules/clusters/clusters.component";
import { ElementsComponent } from "@/modules/elements/elements.component";
import { UsersModule } from "@/modules/users/users.module";
import { ElementsModule } from "@/modules/elements/elements.module";
import { ClustersModule } from "@/modules/clusters/clusters.module";
import { LoginGuard } from "@/core/guards/login.guard";

const childrenRoutes: Routes = [
  {
    path: 'users',
    component: UsersComponent,
  },
  {
    path: 'clusters',
    component: ClustersComponent,
  },
  {
    path: 'elements',
    component: ElementsComponent,
  },
  {
    path: 'explore',
    loadChildren: () => import('./modules/explore/explore.module').then(m => m.ExploreModule),
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./modules/onboarding/onboarding.module').then(m => m.OnboardingModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'waitlist',
    loadChildren: () => import('./modules/waitlist/waitlist.module').then(m => m.WaitlistModule),
  },
  {
    path: 'ip-blacklist',
    loadChildren: () => import('./modules/ip-blacklist/ip-blacklist.module').then(m => m.IpBlacklistModule),
  },
  {
    path: 'block-username',
    loadChildren: () => import('./modules/block-username/block-username.module').then(m => m.BlockUsernameModule),
  },
  {
    path: 'invites',
    loadChildren: () => import('./modules/invites/invites.module').then(m => m.InvitesModule),
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
    canActivate: [LoginGuard],
  },
  {
    path: '', // if set to ** it would conflict with ** specified in children
    children: childrenRoutes,
    canActivate: [AuthenticationGuard],
  },
];

const config: ExtraOptions = {
  useHash: false,
  //enableTracing: true, //useful for debugging navigation
};

@NgModule({
  imports: [
    RouterModule.forRoot(routes, config),
    UsersModule,
    ElementsModule,
    ClustersModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
